import { render, staticRenderFns } from "./renew.vue?vue&type=template&id=08cb7d96&scoped=true&"
import script from "./renew.vue?vue&type=script&lang=js&"
export * from "./renew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cb7d96",
  null
  
)

export default component.exports